export const serviceLink = 'https://qiankuwang.udesk.cn/im_client/?web_plugin_id=100652&group_id=134702';
